import { loadD1C } from "./js/D1C/d1c";


/*Codigo de linea 6 a 99 lo recuperamos de : repsol/main/satellite.js*/

if (typeof DFI_client !== "object") {
  var DFI_client = {};
}



/*-----Carga D1C y Whatsapp D3A----*/
/*Cargamos D1C*/



if(document.getElementById("initWalmeric")===null){
  loadD1C();
}




/*DCL gracias*/
globalThis.DCL_gracias = (resp) => {
  console.log("Lead Exitoso");
  console.log(resp);
  globalThis.DCL.set.forms();
};

globalThis.DFI_client=DFI_client